import React, { useState } from "react";
// import { PieChart, Pie, Tooltip, Cell, LabelList } from "recharts";
// import { Select, MenuItem, Box, Typography, Grid } from "@mui/material"; // Importing MUI components

// Define colors for the PieChart slices
// Define colors for the PieChart slices
// Define colors for the PieChart slices with even lighter shades
// const COLORS = [
//   "#1560BD", // Medium red
//   "#3a7ca5", // Medium green
//   "#45b6fe", // Medium blue
//   "#E0E5FA", // Medium yellow
//   "#50a5f1", // Medium purple
// ];

// Main component for rendering the chart
const Charts = ({ data, type }) => {
  // const [chartValue, setChartValue] = useState("amount"); // Use "amount" as the default field

  // Handling dropdown change to toggle between different chart value fields
  // const handleChange = (event) => {
  //   setChartValue(event.target.value);
  // };

  // Helper function to capitalize the first letter of a string
  // const capitalizeFirstLetter = (str) => {
  //   if (!str) return ""; // Handle empty string
  //   return str.charAt(0).toUpperCase() + str.slice(1);
  // };

  return <div></div>;
};

export default Charts;
